
import { Product, Group } from "@/lib/types";
import {
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

interface UsageFormHeaderProps {
  product?: Product;
  group?: Group;
}

const UsageFormHeader = ({ product, group }: UsageFormHeaderProps) => {
  return (
    <DialogHeader>
      <DialogTitle>
        {product 
          ? `Record Usage of ${product.name}`
          : group 
            ? `Record Usage for ${group.name}`
            : "Record Usage"
        }
      </DialogTitle>
      <DialogDescription>
        Track the supplies you've used.
      </DialogDescription>
    </DialogHeader>
  );
};

export default UsageFormHeader;
